<img [src]="icon.src" [alt]="icon.src"
     [style]="getSize()"
     [style.filter]="invert ? 'invert(' + invert + ')' : 'invert(0)'"
>
